module.exports = __webpack_public_path__ + "files/288a4e472fbe83293df4a3931f8e782a.png";